import { render, staticRenderFns } from "./RoomSign.vue?vue&type=template&id=50ffb8e4&"
import script from "./RoomSign.vue?vue&type=script&lang=js&"
export * from "./RoomSign.vue?vue&type=script&lang=js&"
import style0 from "./RoomSign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports